import { render, staticRenderFns } from "./ElPage.vue?vue&type=template&id=a0d1ad68"
import script from "./ElPage.vue?vue&type=script&lang=js"
export * from "./ElPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports